var map = {
	"./id-0-@2x.png": 41661,
	"./id-0-a@2x.png": 28946,
	"./id-1-@2x.png": 58372,
	"./id-1-a@2x.png": 44505,
	"./id-2-@2x.png": 31531,
	"./id-2-a@2x.png": 54404,
	"./id-3-@2x.png": 6162,
	"./id-3-a@2x.png": 34899,
	"./id-4-@2x.png": 82753,
	"./id-4-a@2x.png": 65726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6036;